export const CACHE_KEY_LIST_HISTORIAN_OFFICES = 'historian-offices';
export const ROUTE_PATH_HISTORIAN_OFFICES = '/configuration/historian-offices';
export const TRANSLATION_PREFIX_HISTORIAN_OFFICES = 'historianOffices';
export const SECURITY_KEY_CNAE_HISTORIAN_OFFICES = 'HISTORIAN_OFFICES';
